var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAimToday01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1984.25 1984.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "545.09 814.26 574.59 812.44 640.74 917.61 646.1 913.76 707.57 814.28 738.66 811.95 740.96 1004.84 699.48 1004.84 697.15 901.51 654.62 963.68 626.73 961.37 586.57 901.51 586.57 1007.13 545.09 1007.13 545.09 814.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.05,1007.13l77.1-193.04,36.05,1.59,73.5,191.45h-43.78l-11.83-34.13-75.97,1.11-11.28,33.02h-43.78ZM374.57,938.25l-24.2-68.91-24.2,68.91h48.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "505.92 814.26 508.22 1007.13 464.44 1007.13 464.44 814.26 505.92 814.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1236.38,997.95v-185.98h84.11c40.23,0,74.88,56.27,74.88,92.99,0,42.06-36.8,92.99-81.79,92.99h-77.19ZM1250.21,984.17h70.28c5.62,0,28.01-13,33.21-17.42,41.03-34.9,33.44-113.82-17.71-135.79-4.15-1.78-21.5-7.52-24.72-7.52h-61.06v160.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1086.05,810.27c144.7-20.84,142.63,213.26-1.88,188.96-93.7-15.76-95.48-174.94,1.88-188.96ZM1086,824c-82.95,12.8-78.93,166.96,19.82,164.59,101.61-2.44,100.58-183.17-19.82-164.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1582.02,995.64l-13.44-.37-21.43-54.41c-25.45,1.84-56.92-3.51-81.62-.44-2.83.35-4.64-.17-6.79,2.42-7.17,8.59-13.53,45.6-20.66,52.89-3.68,3.76-10.25,1.98-15.04,2.21l74.01-187.96h9.75s75.21,185.66,75.21,185.66ZM1540.55,929.07l-38.02-96.46-38.02,96.46h76.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "999.04 811.97 999.05 823.46 932.21 825.74 932.21 997.95 920.68 997.96 918.39 825.74 851.56 825.74 851.56 811.97 999.04 811.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1646.55 911.85 1577.42 809.69 1594.68 811.98 1652.33 896.92 1657.72 893.12 1712.23 811.98 1729.5 809.69 1660.37 909.55 1660.37 995.65 1646.55 995.65 1646.55 911.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1141.91,1076.01v80.36h-13.83v-48.22c-9.11,4.78-14.89,25.7-20.51,30.65-13.55,11.94-22.65-25.84-32.49-30.65v48.22h-13.83v-80.36c4.25-.31,6.82-.58,10.34,2.32,9.26,7.62,18.49,36.92,29.98,45.85,3.49-.13,24.23-41.13,29.98-45.85,3.53-2.9,6.09-2.64,10.34-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1598.16,1162.12c-4.42,21.93-42.12,25.24-55.26,9.18l8.35-7.81c15.5,11.59,36.55,8.78,33.06-14-47,26.49-57.13-51.73-14.97-48.37,5.9.47,11.6,5.48,15.9,4.88.77-.11,3.64-8.61,12.91-4.73-2.46,17.75,3.33,44.3,0,60.85ZM1559.53,1139.76c12.9,12.82,39.17-9.14,22.42-23.48-17.48-14.97-34.16,11.81-22.42,23.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M754.78,1164.41c-3.91,18.06-43.39,24.12-52.8,6.55,5.09-14.84,11.13-1.98,19.58-.85,13.16,1.76,22.9-7.41,21.69-20.62-5.74.47-8.61,4.1-14.95,4.69-40.02,3.75-38.24-59.34,2.16-52.82,4.36.7,8.63,4.69,11.57,4.62.77-.02,2.97-8.57,12.75-4.72-2.67,18.05,3.6,46.51,0,63.14ZM721.88,1113.2c-11.9,3.48-11.91,25.42-.02,28.9,28.91,8.47,27.78-37.03.02-28.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M395.31,1073.72v82.66c-11,4.25-14.11-4.71-15-4.68-3.24.1-5.41,3.87-9.26,4.6-50.4,9.62-41.48-77.18,10.43-50.44v-32.15h13.83ZM362.45,1113.16c-14.26,2.95-15.02,27.52-2.37,31.25,28.45,8.38,29.56-36.87,2.37-31.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.61,1076.26l30.18,80.1-13.45-.36c-4.32-22.89-22.32-14.76-40.38-15.39-7.77,10.49-4.87,18.87-22.2,15.74l32.02-78.92,13.84-1.18ZM305.44,1131.11c1.57-1.48-10.03-37.34-13.79-34.42l-11.45,31.02c.47,5.47,20.43,2.94,25.24,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1010.55,1087.45c-10.81,7.33-10.25,1.36-17.41.07-8.56-1.54-15.91,2.86-14.47,12.09,1.54,9.81,42.49,43.64,48.02,56.74-8.41,4.62-17.79-6.1-19.55-6.27-1.86-.17-9.11,5.34-14,6.14-13.51,2.21-27.34,1.2-33.03-12.71-9.27-22.65,10.79-29.29,11.03-31.87.34-3.59-9.57-13.53-1.8-27.34,9.94-17.65,46.45-4.09,41.2,3.14ZM996.72,1142.58c.98-1.32-14.4-27.39-22.01-20.81-15.35,13.27,5.23,31.1,22.01,20.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M784.74,1073.72v32.15c12.11-4.35,21.33-8.73,32.36,1.04,1.54,1.36,6.81,8.19,6.81,9.29v40.18h-13.83v-35.59c0-11.77-25.35-8.43-25.35,0v35.59h-13.83v-82.66h13.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1213.34,1156.38c-6.74-.46-12.93,2.96-14.93-4.61-46.66,27.13-58.83-54.11-13.89-50.66,5.76.44,10.73,4.96,13.78,4.88.89-.02,4.08-8.98,15.05-4.72v55.11ZM1180.41,1113.21c-13.35,3.99-14.08,29.05-.4,31.67,31.97,6.14,25.14-39.07.4-31.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "793.96 806.23 797.45 802.79 803.17 806.23 803.17 1010.58 799.68 1014.01 793.96 1010.58 793.96 806.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1390.77,1133.42h-41.48c-1.15,10.43,10.4,15.02,19.39,13.75,4.05-.57,8.52-4.76,11.38-4.21,9.66,1.86,6.54,9.2-2.58,12.78-26.94,10.57-53.61-16.82-37.41-41.85,16.24-25.09,56.93-11.55,50.7,19.52ZM1376.34,1115.65c-7.08-6.52-26.73-3.61-27.03,8.57h29.93c1.1-1.02-1.65-7.42-2.9-8.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1291.68,1073.72v52.81c16.43-5.19,17.49-31.87,39.17-25.23l-20.77,26.34,20.77,28.72c-18.97,4.76-26.35-13.84-34.6-27.53-8.88,2.33-2.47,25.53-4.56,27.56h-11.53v-82.67h11.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1478.33,1101.27c10.97-4.26,14.16,4.7,15.05,4.72,5.17.14,10.05-7.04,22.47-4.23,4.32.98,13.17,8.37,13.17,12.14v42.48h-11.52v-35.59c0-7.82-25.35-13.01-25.35,0v35.59h-13.83v-55.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M554.31,1101.27c9.59-3.85,12.04,4.63,12.81,4.72,5.39.63,10.95-7.25,24.66-4.08,4.84,1.12,13.23,10.12,13.23,14.29v40.18h-11.53c-.24-13.55,5.07-50.71-19.13-43.21-2.67.83-8.51,8.21-8.51,9.91v33.29h-11.52v-55.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M895.35,1112.76c-1.5,15.03,20.91,8.59,26.45,20.69,13.78,30.12-42.82,26.29-42.55,14.89.29-12.09,27.53,6.69,32.17-6.89-6.48-10.26-27.69-7.58-29.92-20.79-3.59-21.29,30.49-26.22,41.45-11.36l-7.98,7.47c-5.7-5.32-12.32-4.29-19.63-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M422.97,1112.76c-1.62,15.29,23.18,8.57,27.21,22.3,8.79,30.01-43.5,23.27-43.3,13.28.24-12.07,27.56,6.67,32.17-6.89-6.48-10.26-27.69-7.58-29.92-20.79-3.59-21.29,30.49-26.22,41.45-11.36l-7.98,7.47c-5.7-5.32-12.32-4.29-19.63-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M632.66,1112.76c-.71,16.15,21.78,7.12,26.65,22.85,9.19,29.65-42.94,22.47-42.75,12.73.23-11.98,26.79,5.4,29.9-4.62,3.75-12.07-25.17-8.54-27.65-23.05-3.62-21.27,30.51-26.23,41.45-11.36l-7.98,7.47c-5.7-5.32-12.32-4.29-19.63-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M846.96,1116.2l-13.85-4.6.02-8c4.51-.21,11.72,1.57,13.51-3.79l.31-21.5h13.85s.97,23.14.97,23.14l10.42,2.28.13,9.03h-11.53v43.64h-13.83v-40.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1411.51 1112.75 1397.67 1112.74 1397.68 1103.59 1410.51 1101.42 1412.83 1078.27 1425.35 1078.3 1425.32 1103.58 1436.87 1103.58 1436.87 1112.74 1425.33 1112.75 1425.33 1156.38 1411.51 1156.38 1411.51 1112.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 522.05,
    y: 1076.01,
    width: 13.83,
    height: 80.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1229.47,1101.27c10.99-4.25,14.11,4.7,15,4.68,2.49-.07,21.15-11.39,24.16-1.16,4.46,15.15-25.33,2.65-25.33,16v35.59h-13.83v-55.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1448.38,
    y: 1101.27,
    width: 13.83,
    height: 55.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 674.13,
    y: 1101.27,
    width: 11.52,
    height: 55.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M471.3,1174.75l-6.86-2.31c-.59-4.64,4.72-8.4,4.55-12.63-.1-2.54-11.34-19.55,3.52-19.57,17.02-.02,1.31,27.41-1.21,34.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1629.82,1155.81c-5.16,5.21-15.98,1.34-14.94-7.08,2.16-17.46,26.38-4.46,14.94,7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M674.36,1076.25c4.86-3.4,17.53,4.34,12.55,11.34-6.95,9.76-21.98-4.76-12.55-11.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1452.09,1076.22c9.96-3.17,13.61,8.6,7.95,12.56-10.01,6.99-16.81-9.73-7.95-12.56Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "545.09 814.26 574.59 812.44 640.74 917.61 646.1 913.76 707.57 814.28 738.66 811.95 740.96 1004.84 699.48 1004.84 697.15 901.51 654.62 963.68 626.73 961.37 586.57 901.51 586.57 1007.13 545.09 1007.13 545.09 814.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.05,1007.13l77.1-193.04,36.05,1.59,73.5,191.45h-43.78l-11.83-34.13-75.97,1.11-11.28,33.02h-43.78ZM374.57,938.25l-24.2-68.91-24.2,68.91h48.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "505.92 814.26 508.22 1007.13 464.44 1007.13 464.44 814.26 505.92 814.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1236.38,997.95v-185.98h84.11c40.23,0,74.88,56.27,74.88,92.99,0,42.06-36.8,92.99-81.79,92.99h-77.19ZM1250.21,984.17h70.28c5.62,0,28.01-13,33.21-17.42,41.03-34.9,33.44-113.82-17.71-135.79-4.15-1.78-21.5-7.52-24.72-7.52h-61.06v160.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1086.05,810.27c144.7-20.84,142.63,213.26-1.88,188.96-93.7-15.76-95.48-174.94,1.88-188.96ZM1086,824c-82.95,12.8-78.93,166.96,19.82,164.59,101.61-2.44,100.58-183.17-19.82-164.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1582.02,995.64l-13.44-.37-21.43-54.41c-25.45,1.84-56.92-3.51-81.62-.44-2.83.35-4.64-.17-6.79,2.42-7.17,8.59-13.53,45.6-20.66,52.89-3.68,3.76-10.25,1.98-15.04,2.21l74.01-187.96h9.75s75.21,185.66,75.21,185.66ZM1540.55,929.07l-38.02-96.46-38.02,96.46h76.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "999.04 811.97 999.05 823.46 932.21 825.74 932.21 997.95 920.68 997.96 918.39 825.74 851.56 825.74 851.56 811.97 999.04 811.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1646.55 911.85 1577.42 809.69 1594.68 811.98 1652.33 896.92 1657.72 893.12 1712.23 811.98 1729.5 809.69 1660.37 909.55 1660.37 995.65 1646.55 995.65 1646.55 911.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1141.91,1076.01v80.36h-13.83v-48.22c-9.11,4.78-14.89,25.7-20.51,30.65-13.55,11.94-22.65-25.84-32.49-30.65v48.22h-13.83v-80.36c4.25-.31,6.82-.58,10.34,2.32,9.26,7.62,18.49,36.92,29.98,45.85,3.49-.13,24.23-41.13,29.98-45.85,3.53-2.9,6.09-2.64,10.34-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1598.16,1162.12c-4.42,21.93-42.12,25.24-55.26,9.18l8.35-7.81c15.5,11.59,36.55,8.78,33.06-14-47,26.49-57.13-51.73-14.97-48.37,5.9.47,11.6,5.48,15.9,4.88.77-.11,3.64-8.61,12.91-4.73-2.46,17.75,3.33,44.3,0,60.85ZM1559.53,1139.76c12.9,12.82,39.17-9.14,22.42-23.48-17.48-14.97-34.16,11.81-22.42,23.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M754.78,1164.41c-3.91,18.06-43.39,24.12-52.8,6.55,5.09-14.84,11.13-1.98,19.58-.85,13.16,1.76,22.9-7.41,21.69-20.62-5.74.47-8.61,4.1-14.95,4.69-40.02,3.75-38.24-59.34,2.16-52.82,4.36.7,8.63,4.69,11.57,4.62.77-.02,2.97-8.57,12.75-4.72-2.67,18.05,3.6,46.51,0,63.14ZM721.88,1113.2c-11.9,3.48-11.91,25.42-.02,28.9,28.91,8.47,27.78-37.03.02-28.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M395.31,1073.72v82.66c-11,4.25-14.11-4.71-15-4.68-3.24.1-5.41,3.87-9.26,4.6-50.4,9.62-41.48-77.18,10.43-50.44v-32.15h13.83ZM362.45,1113.16c-14.26,2.95-15.02,27.52-2.37,31.25,28.45,8.38,29.56-36.87,2.37-31.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.61,1076.26l30.18,80.1-13.45-.36c-4.32-22.89-22.32-14.76-40.38-15.39-7.77,10.49-4.87,18.87-22.2,15.74l32.02-78.92,13.84-1.18ZM305.44,1131.11c1.57-1.48-10.03-37.34-13.79-34.42l-11.45,31.02c.47,5.47,20.43,2.94,25.24,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1010.55,1087.45c-10.81,7.33-10.25,1.36-17.41.07-8.56-1.54-15.91,2.86-14.47,12.09,1.54,9.81,42.49,43.64,48.02,56.74-8.41,4.62-17.79-6.1-19.55-6.27-1.86-.17-9.11,5.34-14,6.14-13.51,2.21-27.34,1.2-33.03-12.71-9.27-22.65,10.79-29.29,11.03-31.87.34-3.59-9.57-13.53-1.8-27.34,9.94-17.65,46.45-4.09,41.2,3.14ZM996.72,1142.58c.98-1.32-14.4-27.39-22.01-20.81-15.35,13.27,5.23,31.1,22.01,20.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M784.74,1073.72v32.15c12.11-4.35,21.33-8.73,32.36,1.04,1.54,1.36,6.81,8.19,6.81,9.29v40.18h-13.83v-35.59c0-11.77-25.35-8.43-25.35,0v35.59h-13.83v-82.66h13.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1213.34,1156.38c-6.74-.46-12.93,2.96-14.93-4.61-46.66,27.13-58.83-54.11-13.89-50.66,5.76.44,10.73,4.96,13.78,4.88.89-.02,4.08-8.98,15.05-4.72v55.11ZM1180.41,1113.21c-13.35,3.99-14.08,29.05-.4,31.67,31.97,6.14,25.14-39.07.4-31.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "793.96 806.23 797.45 802.79 803.17 806.23 803.17 1010.58 799.68 1014.01 793.96 1010.58 793.96 806.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1390.77,1133.42h-41.48c-1.15,10.43,10.4,15.02,19.39,13.75,4.05-.57,8.52-4.76,11.38-4.21,9.66,1.86,6.54,9.2-2.58,12.78-26.94,10.57-53.61-16.82-37.41-41.85,16.24-25.09,56.93-11.55,50.7,19.52ZM1376.34,1115.65c-7.08-6.52-26.73-3.61-27.03,8.57h29.93c1.1-1.02-1.65-7.42-2.9-8.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1291.68,1073.72v52.81c16.43-5.19,17.49-31.87,39.17-25.23l-20.77,26.34,20.77,28.72c-18.97,4.76-26.35-13.84-34.6-27.53-8.88,2.33-2.47,25.53-4.56,27.56h-11.53v-82.67h11.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1478.33,1101.27c10.97-4.26,14.16,4.7,15.05,4.72,5.17.14,10.05-7.04,22.47-4.23,4.32.98,13.17,8.37,13.17,12.14v42.48h-11.52v-35.59c0-7.82-25.35-13.01-25.35,0v35.59h-13.83v-55.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M554.31,1101.27c9.59-3.85,12.04,4.63,12.81,4.72,5.39.63,10.95-7.25,24.66-4.08,4.84,1.12,13.23,10.12,13.23,14.29v40.18h-11.53c-.24-13.55,5.07-50.71-19.13-43.21-2.67.83-8.51,8.21-8.51,9.91v33.29h-11.52v-55.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M895.35,1112.76c-1.5,15.03,20.91,8.59,26.45,20.69,13.78,30.12-42.82,26.29-42.55,14.89.29-12.09,27.53,6.69,32.17-6.89-6.48-10.26-27.69-7.58-29.92-20.79-3.59-21.29,30.49-26.22,41.45-11.36l-7.98,7.47c-5.7-5.32-12.32-4.29-19.63-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M422.97,1112.76c-1.62,15.29,23.18,8.57,27.21,22.3,8.79,30.01-43.5,23.27-43.3,13.28.24-12.07,27.56,6.67,32.17-6.89-6.48-10.26-27.69-7.58-29.92-20.79-3.59-21.29,30.49-26.22,41.45-11.36l-7.98,7.47c-5.7-5.32-12.32-4.29-19.63-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M632.66,1112.76c-.71,16.15,21.78,7.12,26.65,22.85,9.19,29.65-42.94,22.47-42.75,12.73.23-11.98,26.79,5.4,29.9-4.62,3.75-12.07-25.17-8.54-27.65-23.05-3.62-21.27,30.51-26.23,41.45-11.36l-7.98,7.47c-5.7-5.32-12.32-4.29-19.63-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M846.96,1116.2l-13.85-4.6.02-8c4.51-.21,11.72,1.57,13.51-3.79l.31-21.5h13.85s.97,23.14.97,23.14l10.42,2.28.13,9.03h-11.53v43.64h-13.83v-40.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1411.51 1112.75 1397.67 1112.74 1397.68 1103.59 1410.51 1101.42 1412.83 1078.27 1425.35 1078.3 1425.32 1103.58 1436.87 1103.58 1436.87 1112.74 1425.33 1112.75 1425.33 1156.38 1411.51 1156.38 1411.51 1112.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 522.05,
    y: 1076.01,
    width: 13.83,
    height: 80.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1229.47,1101.27c10.99-4.25,14.11,4.7,15,4.68,2.49-.07,21.15-11.39,24.16-1.16,4.46,15.15-25.33,2.65-25.33,16v35.59h-13.83v-55.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1448.38,
    y: 1101.27,
    width: 13.83,
    height: 55.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 674.13,
    y: 1101.27,
    width: 11.52,
    height: 55.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.3,1174.75l-6.86-2.31c-.59-4.64,4.72-8.4,4.55-12.63-.1-2.54-11.34-19.55,3.52-19.57,17.02-.02,1.31,27.41-1.21,34.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1629.82,1155.81c-5.16,5.21-15.98,1.34-14.94-7.08,2.16-17.46,26.38-4.46,14.94,7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M674.36,1076.25c4.86-3.4,17.53,4.34,12.55,11.34-6.95,9.76-21.98-4.76-12.55-11.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1452.09,1076.22c9.96-3.17,13.61,8.6,7.95,12.56-10.01,6.99-16.81-9.73-7.95-12.56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAimToday01);
export default __webpack_public_path__ + "static/media/AIM-Today-01.202c5f70515e51120d500f0e8f66145c.svg";
export { ForwardRef as ReactComponent };